import {axiosForLogistics} from '@/utils/axios.js'

//登录接口
export function Login(postData) {
    return axiosForLogistics.post('/api/UserLogin/Login', postData);
}
//获取顺丰订单-路由信息（路线信息）
export function GetSFOrderRoute(ddbm) {
    return axiosForLogistics.get('/api/ExpressModule/GetSFOrderRoute?ddbm=' + ddbm);
}